# DEPRECATED: Use appRoute instead
# Returns ``$clientUrl`` with ``/dashapp`` appended.
angular.module('rjmNg.services').factory '$clientAppUrl', [
  "$clientUrl"
  (
    $clientUrl
  ) ->
    (url) ->
      $clientUrl("/dashapp#{url}")
]
